<script>
import { mapGetters } from 'vuex'
import {
  eventPrices,
  monthlyPrices,
  yearlyPrices,
  yearlyEduPrices,
  testPriceIds,
  livePriceIds,
  getNameFromPrice
} from '~/common/prices.js'

export default {
  layout: 'blank',
  auth: false,
  data () {
    this.pk = process.env.STRIPE_PK

    return {
      isMounted: false,
      annualSwitch: 'yearly',
      autoRenewValue: false,
      // period must match to price ids from vuex store
      period: 'yearly', // ['monthly', 'yearly', 'oneTime']
      playerLimitKey: 1,
      playerLimits: [100, 250, 500, 1000],
      successUrl: process.env.SITE_URL + '/decks?success',
      cancelUrl: process.env.SITE_URL + '/decks?cancel',
      couponIds: {
        test: {
          starter: 'cfpvWDVd',
          pro100: 'vVu02LBD',
          pro250: 'uFC9CenH',
          pro500: 'ehnnkxFa',
          pro1000: '4r5vpGhA'
        },
        live: {
          starter: 'd4rc0Z7s',
          pro100: 'uz2PX1rJ',
          pro250: 'fxPYVb5s',
          pro500: 'ljKjfHFo',
          pro1000: 'yYw7P1Wt'
        }
      },
      eduDescriptions: {
        oneTime: {
          starter: 'Engaging lessons for teachers and small classrooms',
          pro: 'Events for large classes, departments, and schools'
        },
        monthly: {
          starter: 'Engaging lessons for teachers and small classrooms',
          pro: 'Events for large classes, departments, and schools'
        },
        yearly: {
          starter: 'Engaging lessons for teachers and small classrooms',
          pro: 'Events for large classes, departments, and schools'
        }
      },
      descriptions: {
        oneTime: {
          starter: 'Engaging meetings for small teams and organizations',
          pro: 'Branded events for larger teams, companies, and departments'
        },
        monthly: {
          starter: 'Engaging meetings for small teams and organizations',
          pro: 'Branded events for larger teams, companies, and departments'
        },
        yearly: {
          starter: 'Engaging meetings for small teams and organizations',
          pro: 'Branded events for larger teams, companies, and departments'
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'eventPasses',
      'isPassActive'
    ]),
    autoRenew: {
      get () {
        return this.autoRenewValue
      },
      set (val) {
        if (val === true && this.period === 'oneTime') {
          this.period = 'monthly'
        } else if (val === false && this.period === 'monthly') {
          this.period = 'oneTime'
        }
        this.autoRenewValue = val
      }
    },
    isAnnual () {
      return this.period === 'yearly'
    },
    description () {
      return this.isEdu
        ? this.eduDescriptions[this.period]
        : this.descriptions[this.period]
    },
    title () {
      // if (this.period === 'oneTime') {
      //   return {
      //     starter: 'Starter Pass',
      //     pro: 'Pro Pass'
      //   }
      // }
      if (this.period === 'monthly' || this.period === 'oneTime') {
        return {
          starter: this.isEdu ? 'Starter Edu' : 'Starter',
          pro: this.isEdu ? 'Pro Edu' : 'Pro'
        }
      }
      if (this.period === 'yearly') {
        return {
          starter: this.isEdu ? 'Starter Edu' : 'Starter',
          pro: this.isEdu ? 'Pro Edu' : 'Pro'
        }
      }
      return {}
    },
    cta () {
      if (this.period === 'oneTime') {
        return {
          starter: 'Upgrade to Starter',
          pro: 'Upgrade to Pro'
        }
      }

      if (this.period === 'monthly') {
        return {
          starter: 'Upgrade to Starter',
          pro: 'Upgrade to Pro'
        }
      }

      if (this.period === 'yearly') {
        return {
          starter: 'Upgrade to Starter',
          pro: 'Upgrade to Pro'
        }
      }
      return {}
    },
    priceSubtitle () {
      if (this.period === 'oneTime') {
        return { starter: 'one month only', pro: 'one month only' }
      }

      const starterPrice = this.prices.starter.total
      const proPrice = this.prices[`pro${this.proPlayerLimit}`].total

      return {
        pro: '$' + proPrice + ' billed ' + this.period,
        starter: '$' + starterPrice + ' billed ' + this.period
      }
    },
    userType () {
      return this.user?.metadata?.userType
    },
    isEdu () {
      if (this.$route.name === 'embed-pricing') {
        return this.$route.query?.type === 'edu'
      } else {
        return this.user?.isEdu === true
      }
    },
    proPlayerLimit () {
      return this.playerLimits[this.playerLimitKey]
    },
    optString () {
      const item = 'b2NhbC5zbGlkZ'

      const opts = {
        mode: this.mode,
        line_items: this.getLineItems('starter'),
        success_url: this.successUrl,
        cancel_url: this.cancelUrl,
        client_reference_id: this.user.id
      }

      if (this.user.stripe_customer) {
        opts.customer = this.user.stripe_customer
      } else if (this.user.email) {
        opts.customer_email = this.user.email
      }

      return item + btoa(JSON.stringify(opts))
    },
    mode () {
      return this.period === 'oneTime' ? 'payment' : 'subscription'
    },
    prices () {
      if (this.period === 'yearly') { return this.isEdu ? yearlyEduPrices : yearlyPrices }
      if (this.period === 'oneTime') { return eventPrices }
      if (this.period === 'monthly') { return monthlyPrices }
      return {}
    },
    priceIds () {
      const isDev = this.$store.state.isDev
      return isDev ? testPriceIds : livePriceIds
    },
    loggedIn () {
      return this.$auth.loggedIn && this.isMounted
    },
    user () {
      return this.$store.state.user
    },
    isSubscriber () {
      return this.$store.getters.isSubscriber
    },
    isClient () {
      return process.client
    },
    increaseLimitDisabled () {
      return this.playerLimitKey === (this.playerLimits.length - 1)
    },
    decreaseLimitDisabled () {
      return this.playerLimitKey < 1
    }
  },
  watch: {
    period (newVal) {
      if (newVal === 'yearly') {
        this.annualSwitch = 'yearly'
      } else {
        this.annualSwitch = 'monthly'
      }
    }
  },
  mounted () {
    this.isMounted = true
  },
  methods: {
    setPeriod (period) {
      if (period === 'oneTime' && this.autoRenew === true) {
        this.period = 'monthly'
      } else {
        this.period = period
      }
    },
    getNameFromPrice,
    getLineItems (type) {
      let period = this.period
      if (period === 'yearly' && this.isEdu) { period = 'yearlyEdu' }

      return [
        {
          price: this.priceIds[period][type], // type is pro or starter
          quantity: 1
        }
      ]
    },
    getOptions (type, couponId) {
      const item = 'b2NhbC5zbGlkZ'

      // get dollar amount for Google Analytics via success redirect
      const total = this.prices[type].total

      const opts = {
        mode: this.mode,
        line_items: this.getLineItems(type), // type is pro or starter
        success_url: this.successUrl + '&amt=' + total,
        cancel_url: this.cancelUrl + '&amt=' + total,
        client_reference_id: this.user.id
      }

      if (couponId) {
        opts.discounts = [{ coupon: couponId }]
      }

      if (this.user.stripe_customer) {
        opts.customer = this.user.stripe_customer
      } else if (this.user.email) {
        opts.customer_email = this.user.email
      }

      return item + btoa(JSON.stringify(opts))
    },
    async startCheckout (event, type, couponId) {
      event.target.classList.add('is-loading')
      try { this.trackCheckout(type) } catch (e) { console.error(e) }
      const options = { options: this.getOptions(type, couponId) }

      this.log(`starting stripe checkout with type ${type} and coupon ${couponId}`)

      const url = process.env.FUNC_URL || process.env.SITE_URL + '/api'
      const { data } = await this.$axios.post(url + '/stripe-checkout-session', options)
      if (data.url) {
        top.location = data.url
      } else {
        this.trackEvent('Checkout Error')
        this.throwError('Something went wrong, contact us or try again')
        event.target.classList.remove('is-loading')
      }
    },
    trackCheckout (type) {
      const total = this.isAnnual
        ? Number(yearlyPrices[type].total)
        : Number(eventPrices[type].total)

      this.$gtag.event('begin_checkout', {
        items: [
          { item_name: getNameFromPrice(total) }
        ]
      })

      this.posthogCapture('upgrade:start_checkout', {
        plan_name: getNameFromPrice(total),
        amount: total
      })
    },
    increasePlayerLimit () {
      if (!this.increaseLimitDisabled) {
        this.playerLimitKey++
      }
    },
    decreasePlayerLimit () {
      if (!this.decreaseLimitDisabled) {
        this.playerLimitKey--
      }
    }
  }
}
</script>
